import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-table-of-contents" }
const _hoisted_2 = {
  class: "gfu-table-of-contents__list gfu-list",
  "data-qa": "crowdfunding-description-navigation"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass($options.wrapperClasses)
    }, [
      _createElementVNode("nav", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSections, (section, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: section.urlName
          }, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(['gfu-table-of-contents__item gfu-list-item', {'_pt-0': index === 0, '_pb-0': index === (_ctx.pageSections.length - 1)}]),
              "active-class": "is-active",
              to: { name: 'page-section', params: { section: section.urlName } },
              "data-qa": `sidebar-category-section:${section.name}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(section.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "to", "data-qa"]),
            (section.sections && section.sections.length)
              ? (_openBlock(), _createElementBlock("nav", {
                  key: `nav-${section.urlName}`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.sections, (subSection) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: `${section.urlName}/${subSection.urlName}`,
                      class: "gfu-table-of-contents__item gfu-list-subitem",
                      "active-class": "is-active",
                      to: { name: 'page-section', params: { section: section.urlName, subSection: subSection.urlName } },
                      "data-qa": `sidebar-category-section:${subSection.name}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(subSection.name), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "data-qa"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 2 /* CLASS */)
  ]))
}